
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vowscollection",
      function () {
        return require("private-next-pages/vowscollection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vowscollection"])
      });
    }
  